import axios from 'axios';

export const syncGntcConfig = () => {
  (window as any).gntcConfig = {
    httpClient: axios,
  };
};
